import React from 'react';

var Fluxxor = require('fluxxor');
import { FluxMixin, StoreWatchMixin, flux} from '../../../../flux';

import {Link} from 'react-router';

var ForgotPassword = React.createClass({
	mixins: [FluxMixin, StoreWatchMixin("MainStore")],
	getStateFromFlux: function(){
		var flux = this.getFlux();
		return{
				forgotUsernameError: flux.store("MainStore").forgotUsernameError,
				signUpPopup: flux.store("MainStore").signUpPopup
		}
	},
	getInitialState: function(){
		return{
			username: "",
			userclass: "",
			msg: ""
		}
	},
	handleUsernameChange: function(e){
		this.setState({username: e.target.value, userclass: "", msg: ""});
		this.clearLoginErrors();
	},
	sendClick: function(){
		if(this.state.username.trim() === ""){
		    this.setState({userclass: "field__error--input", msg: "Error: Please enter your Username"});
		} else {
			this.getFlux().actions.resetPassword("submit", this.state.username);
		}
	},
	handleCloseClick: function(){
		this.getFlux().actions.resetPassword("close");
		this.clearLoginErrors();
	},
	handleStopPropagation: function(e){
		e.stopPropagation();
	},
	backToLogin: function(){
		this.getFlux().actions.backToLogin(this.state.signUpPopup);
		this.clearLoginErrors();
	},
	clearLoginErrors: function(){
		this.getFlux().actions.clearLoginErrors();
	},
	render: function(){
		var userclass = "", msg = "";	
		 if(this.state.forgotUsernameError){
			this.state.userclass = "field__error--input";
			this.state.msg = "Error: This Username does not exist."
		} 
		return(
			<div className="modal__mask" onClick = {this.handleCloseClick}> 
				<div className="modal__content modal--md" onClick = {this.handleStopPropagation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Forgot Your Password?</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick} >
				    	<i className="fa  fa-close"> </i>
				    </a> 
				  </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Enter your Blended Username and we will send a reset link to you via email if your Username is correct. If you do not receive an email, check your spam folder, or try again.</p>
				    </div>
				    <div className="form__row clearfix">
				      <p><i className="text-dark">*</i> We can only send you a reset link if you have already given us your email.</p>
				    </div>
				    <div className="form__row clearfix">
				      <div className="form__cell">
				      { this.state.userclass != "" ?
				        <p className="field__error--text">{this.state.msg}</p> : null }
				        <div className={this.state.userclass}>
				          <input type="text" onChange = {this.handleUsernameChange} value={this.state.username} placeholder="Username"/>
				        </div>
				      </div>
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.backToLogin}>Back to Login</button>
				      <button className="btn__lg bg-dark"  onClick = {this.sendClick}>Send Email</button>
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

export {ForgotPassword}


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SignUpPopup/ForgotPasswordPage/index.jsx
 **/